import Home from './containers/Home';

export default Home;



// WEBPACK FOOTER //
// ./src/scenes/Home/index.ts